module.exports = __webpack_public_path__ + "img/api-n.ab189765.png";